<template>
  <div class="subcription-section f-column f-align-center">
    <div class="subcription-section_inner f-align-center f-column mt-6 mb-16">
      <transition-group
        name="fade"
        mode="out-in"
        tag="div"
        class="f-column f-align-center position-relative w-100"
        style="min-height: 15rem"
      >
        <TestimonialBox
          v-for="(item, idx) in items"
          v-show="slideshowIndex === idx"
          :key="item.id"
          class="position-absolute"
          :name="item.name"
          :bio="item.bio"
          :text="item.text"
          :img="item.img"
        >
          <div class="d-flex f-justify-center">
            <div
              v-for="(item, idx) in items"
              :key="item.id"
              :class="{ 'slideshow-circle_active': slideshowIndex === idx }"
              class="slideshow-circle"
              @click="reset(idx)"
            ></div>
          </div>
        </TestimonialBox>
      </transition-group>
    </div>
  </div>
</template>

<script>
import TestimonialBox from '@/components/lib/Slideshow/TestimonialBox'

export default {
  name: 'TestimonialSlideshow',

  components: {
    TestimonialBox,
  },
  props: {
    items: {
      default: () => [{ name: '', bio: '', text: '', img: '' }],
    },
  },
  data() {
    return {
      intervalID: 0,
      time: 12000,
      slideshowIndex: 0,
      // items: ['one', 'two'],
    }
  },
  created() {
    this.reset()
  },
  beforeUnmount() {
    clearInterval(this.intervalID)
  },
  methods: {
    reset(index = 0) {
      // console.log(this.items)
      clearInterval(this.intervalID)
      this.slideshowIndex = index
      this.startSlideshow()
    },
    startSlideshow() {
      this.intervalID = setInterval(() => {
        const index = this.slideshowIndex + 1
        this.slideshowIndex = index > this.items.length - 1 ? 0 : index
      }, this.time)
    },
  },
}
</script>

<style lang="scss" scoped>
.slideshow-circle {
  border-radius: 50%;
  background: var(--clr-black-3);
  height: 0.7rem;
  width: 0.7rem;
  margin: 0 0.25rem;
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    background: var(--clr-grey-2);
  }
  &_active {
    background: var(--clr-grey-2);
  }
}
</style>
